import { useMemo } from "react";
import { useTable } from "react-table";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  convertToTilteCase,
  defaultDateDisplay,
  defaultDateOnlyDisplay,
  formatCurrency,
} from "../../../../helpers";
import { pathConstants } from "../../../../routes/pathContants";

export const useTransactionTable = ({ transactions }) => {
  const { currency_code } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );

  const columns = useMemo(
    () => [
      {
        Header: "Trx Ref",
        accessor: "id",
        Cell: ({ cell: { value }, row }) => (
          <span>
            <Link
              style={{ fontSize: "12px" }}
              className="purple--text"
              to={pathConstants.ACCOUNTING_CHART_ACCOUNT_TRANSACTION_DETAILS({
                id: value,
              })}
            >
              <span>{value}</span>
            </Link>
            <span className="d-block">
              {defaultDateDisplay(row?.original?.created_at)}
            </span>
          </span>
        ),
      },
      {
        Header: "Journal Ref",
        accessor: "journal_line_item",
        Cell: ({ cell: { value } }) =>
          value?.journal_entry?.reference ? (
            <Link
              style={{ fontSize: "12px" }}
              className="purple--text"
              to={pathConstants.ACCOUNTING_JOURNAL_ENTRY_DETAILS({
                reference: value?.journal_entry?.reference,
              })}
            >
              <span>{value?.journal_entry?.reference}</span>
            </Link>
          ) : (
            "N/A"
          ),
      },
      {
        Header: "Description",
        accessor: "description",
        Cell: ({ cell: { value } }) =>
          value ? convertToTilteCase(value) : "N/A",
      },
      {
        Header: "Type",
        accessor: "type",
        Cell: ({ cell: { value } }) =>
          value ? convertToTilteCase(value) : "N/A",
      },
      {
        Header: "Payment Method",
        accessor: "payment_method_label",
        Cell: ({ cell: { value } }) => value || "N/A",
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ cell: { value }, row }) => (
          <span>
            {formatCurrency({
              value: Math.abs(value),
              currencyCode: currency_code,
            })}
          </span>
        ),
      },
      {
        Header: "Initiator",
        accessor: "initiator",
        Cell: ({ cell: { value } }) =>
          value?.first_name || value?.last_name
            ? `${value?.first_name || ""} ${value?.last_name || ""}`.trim()
            : "N/A",
      },
      {
        Header: "Trx Date",
        accessor: "transaction_date",
        Cell: ({ cell: { value } }) =>
          value ? defaultDateOnlyDisplay(value) : "N/A",
      },
      {
        Header: "Store",
        accessor: "store",
        Cell: ({ cell: { value } }) =>
          value ? (
            <span
              style={{
                background: "#F2EDFE",
                padding: "6px",
                borderRadius: "8px",
                fontSize: "10px",
              }}
              className="gray--text font-bold"
            >
              {value?.name}
            </span>
          ) : (
            "N/A"
          ),
      },
    ],
    [currency_code],
  );

  const instance = useTable({
    columns,
    data: transactions || [],
  });

  return {
    instance,
  };
};

export default useTransactionTable;
